import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from 'js-cookie'


export const getAllPostReel = createApi({
  reducerPath: "getAllPostReel",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token || Cookies.get("TheShow_Admin_Token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getBuzz: builder.query({
      query: ({ page, limit, search }) => ({
        url: `/admin/posts/buzz?limit=${limit}&page=${page}${search ? `&search=${search}` : ''}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getMotionpix: builder.query({
      query: ({ page, limit, search }) => ({
        url: `/admin/posts/motionpix?limit=${limit}&page=${page}${search ? `&search=${search}` : ''}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getTrailer: builder.query({
      query: ({ limit, page, status, search }) => ({
        url: `/admin/posts/trailer?limit=${limit}&page=${page}&status=${status}${search ? `&search=${search}` : ''}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getPostDetails: builder.query({
      query: ({ id, token }) => ({
        url: `/posts/${id}/details`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getPostComments: builder.query({
      query: ({ id, token }) => ({
        url: `/posts/${id}/comments`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getPostReactions: builder.query({
      query: ({ id, token }) => ({
        url: `/posts/${id}/reactions`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useGetPostDetailsQuery,
  useGetBuzzQuery,
  useGetMotionpixQuery,
  useGetTrailerQuery,
  useGetPostCommentsQuery,
  useGetPostReactionsQuery
} = getAllPostReel;
